export class AuthenticationError extends Error {
	static get name() {
		return 'AuthenticationError';
	}
	constructor(...params) {
		super(...params);
		// this.message = 'Authentication failed.';
	}
}
